export default __webpack_public_path__ + "static/media/BermudaResort.e375af1d.jpg";